import type { getAiPayrollBudget } from "../../worker/core/team/aiFinances.baseball.ts";
import { helpers } from "../util/helpers.ts";

export const AiPayrollBudget = ({ budget }: {
	budget: Awaited<ReturnType<typeof getAiPayrollBudget>>;
}) => {
	if (!budget) return null;
	const money = (amount: number) => helpers.formatCurrency(amount / 1000, "M");
	return (
		<section className="border rounded p-3 mb-3">
			<h3>Orçamento de folha da IA — {budget.season}</h3>
			<div>Orçamento: <b>{money(budget.amount)}</b></div>
			<div>Folha considerada: <b>{money(budget.payroll)}</b></div>
			<div className={budget.room < 0 ? "text-danger" : "text-success"}>
				{budget.room < 0 ? "Acima do orçamento" : "Espaço disponível"}: <b>{money(Math.abs(budget.room))}</b>
			</div>
			<p className="small text-body-secondary mb-0 mt-2">
				É o limite de planejamento usado pela IA em contratações e promoções.
				Inclui salários de dispensados ainda devidos; salários nas Minors ficam fora.
				O limite de luxury tax é separado. Um jogador pode estar pronto e ter sua promoção barrada pelo orçamento.
				{budget.provisional ? " Referência provisória: o plano anual ainda não foi calculado." : null}
			</p>
		</section>
	);
};
